import { CookieConsent, COOKIE_CONSENT_KEY } from '../config/legal';

export function getCookieConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as CookieConsent;
  } catch {
    return null;
  }
}

export function setCookieConsent(analytics: boolean): CookieConsent {
  const consent: CookieConsent = {
    essential: true,
    analytics,
    consentedAt: new Date().toISOString(),
  };
  localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent));
  return consent;
}

export function hasCookieConsent(): boolean {
  return getCookieConsent() !== null;
}

export function isAnalyticsAllowed(): boolean {
  return getCookieConsent()?.analytics === true;
}
